// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconPinWinery = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M12 24a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM12 13a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM6 13.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM18 13.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM15 19a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM9 19a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM18 1c0-.265-.14-.52-.39-.707A1.586 1.586 0 0016.666 0H9.333c-.353 0-.692.105-.942.293C8.14.48 8 .735 8 1c0 .265.14.52.39.707.25.188.589.293.942.293h7.334c.353 0 .692-.105.942-.293C17.86 1.52 18 1.265 18 1z"
      fill="#000"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.512 3.16C13.143 3.98 13 5.072 13 6a1 1 0 11-2 0c0-1.072.157-2.48.688-3.66C12.232 1.13 13.264 0 15 0a1 1 0 110 2c-.664 0-1.132.369-1.488 1.16z"
      fill="#000"
    />
  );
export default SvgIconPinWinery;
